import angular, {IModule, IQService} from "angular";
import {regNavn} from "../tredjepartsTjenestenavn";

export interface DetteErNyttDialogInterface {
    erFerdig(): angular.IPromise<any>;
}

export class DetteErNyttDialogMock implements DetteErNyttDialogInterface {
    static regNavn = "felles.tjenester.modulspesifikke.DetteErNyttDialog";

    constructor(private $q: IQService) {
    }

    static registrerTjenester(angular: IModule) {
        angular
          .service(DetteErNyttDialogMock.regNavn, DetteErNyttDialogMock.forInjisering());
    }

    private static forInjisering() {
        return [regNavn.ng.$q, DetteErNyttDialogMock]
    }

    erFerdig(): angular.IPromise<any> {
        return this.$q.resolve();
    }
}
